import React from 'react'

const Interview_Mock_Test_1D = () => {
  return (
    <div>
      <h1>Mock Test 4</h1>
    </div>
  )
}

export default Interview_Mock_Test_1D
